import Vue from 'vue';
import axios from 'axios';
import serialize from 'json-form-data';
import {addAuthKey} from '@/helpers/addAuthKeyToUrl';

const api_url = '/index.php';

const state = () => ({
    userId: '',
    transactionTypes: [],
    transactionTypesForLs: [],
    allTransactionTypes: [],
    transactionReasons: [],
    allTransactionReasons: [],
    workersList: [],
    currentUserWorker: {},
    companies: [],
    employeeInfo: {},
    filialsList: [],
});

const mutations = {
    setTransactionTypes(state, transactionTypes) {
        state.transactionTypes = transactionTypes;
    },
    setTransactionTypesForLs(state, transactionTypes) {
        state.transactionTypesForLs = transactionTypes;
    },
    setAllTransactionTypes(state, transactionTypes) {
        state.allTransactionTypes = transactionTypes;
    },
    setTransactionReasons(state, transactionReasons) {
        state.transactionReasons = transactionReasons;
    },
    setAllTransactionReasons(state, transactionReasons) {
        state.allTransactionReasons = transactionReasons;
    },
    setWorkersList(state, workersList) {
        state.workersList = workersList;
    },
    setCurrentUserWorker(state, currentUserWorker) {
        state.currentUserWorker = currentUserWorker;
    },
    setCompanies(state, companies) {
        state.companies = [];
        state.companies = companies;
    },
    setEmployeeInfo(state, employeeInfo) {
        state.employeeInfo = employeeInfo;
    },
    setUserId(state, userId) {
        state.userId = userId;
    },
    setFilialsList(state, filialsList) {
        state.filialsList = filialsList;
    },
};

const actions = {
    async fetchTransactionTypes({commit, state, rootState}, type) {
        const token = rootState.authToken;

        let data;

        if (type) {
            const request = await axios.get(
                addAuthKey(
                    `${api_url}?r=api/transaction-type/index&transaction_type=${type}`,
                    token));
            data = request.data;
        }

        commit('setTransactionTypes', data);

        const {data: dataAll} = await axios.get(
            addAuthKey(`${api_url}?r=api/transaction-type/index`, token));

        commit('setAllTransactionTypes', dataAll);
    },
    async fetchTransactionTypesForLs({commit, state, rootState}, type) {
        const token = rootState.authToken;

        const {data} = await axios.get(
            addAuthKey(
                `${api_url}?r=api/worker-profile/transaction-types&type=${type}&dropdown_type=${type ===
                'withdraw' ? 1 : 2}`, token));

        commit('setTransactionTypesForLs', data);
    },
    async fetchTransactionReasons({commit, state, rootState}, type) {
        const token = rootState.authToken;

        const {data} = await axios.get(
            addAuthKey(
                `${api_url}?r=api/worker-profile/reason-list&type=${type}`,
                token));

        commit('setTransactionReasons', data);
    },
    async fetchFilialsList({commit, state, rootState}) {
        const token = rootState.authToken;

        const {data} = await axios.get(
            addAuthKey(`${api_url}/?r=api/directory/filial-sort`, token));

        commit('setFilialsList', data);

        return data;
    },
    async fetchMoneySourcesList({commit, state, rootState}) {
        const token = rootState.authToken;

        const {data} = await axios.get(
            addAuthKey(
                `${api_url}/?r=api/money-source/index&status_type=active`,
                token));

        return data;
    },
    async fetchVacationSickList(
        {commit, state, rootState}, {workerId, category}) {
        const token = rootState.authToken;

        const {data} = await axios.get(
            addAuthKey(
                `${api_url}/?r=api/finance-transaction/vacation-sick-list&worker_id=${workerId}&category=${category}`,
                token));

        return data;
    },
    async fetchWorkersList({commit, state, rootState}) {
        const token = rootState.authToken;

        const {data} = await axios.get(
            addAuthKey(`${api_url}/?r=api/worker-profile/worker-list`, token));

        commit('setWorkersList', data);
    },
    async fetchNewWorkersList({commit, state, rootState}) {
        const token = rootState.authToken;

        const {data} = await axios.get(
            addAuthKey(`${api_url}/?r=api/worker/list-with-photo`, token));

        commit('setWorkersList', data);
    },
    async fetchCurrentUserWorker({commit, state, rootState}) {
        const token = rootState.authToken;

        await axios.get(
            addAuthKey(`${api_url}/?r=api/worker-profile/current-user-worker`,
                token)).
            then(response => {
                commit('setCurrentUserWorker', response.data);
            });
    },
    async fetchCompanies({commit, state, rootState}) {
        const token = rootState.authToken;

        const {data} = await axios.get(
            addAuthKey(`${api_url}/?r=api/directory/company`, token));

        commit('setCompanies', data);

        return data;
    },
    async fetchEmployeeInfo({commit, state, rootState}, employeeId) {
        const token = rootState.authToken;

        const {data} = await axios.get(
            addAuthKey(`${api_url}/?r=api/employee/view&id=${employeeId}`,
                token));

        commit('setEmployeeInfo', data);
        commit('setUserId', rootState.userId);
    },
    async fetchCreateTransaction({commit, state, rootState}, params) {
        const token = rootState.authToken;

        const fd = serialize(params);

        await axios.post(
            addAuthKey(`${api_url}/?r=api/worker-profile/create-transaction`,
                token),
            fd);
    },
    async fetchEditTransaction({commit, state, rootState}, {params, id}) {
        const token = rootState.authToken;

        const fd = serialize(params);

        await axios.post(
            addAuthKey(
                `${api_url}/?r=api/worker-profile/edit-transaction&id=${id}`,
                token),
            fd);
    },
};

const getters = {};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};